(() => {
  const controllerKey = '__spacetekJudgeMeTestimonialsModalController';

  if (window[controllerKey]) {
    return;
  }

  const modalSelector = '.jdgm-modal.jdgm-widget-revamp';
  const sourceSelector = '.spacetek-judgeme-testimonials[data-sjt-modal-styling="true"] .jdgm-card.jdgm-testimonial';
  const excludedSourceSelector = '.jdgm-arrow, .jdgm-product-name, a';
  const modalMarkerClass = 'spacetek-judgeme-testimonials-modal';
  const modalVariableNames = [
    '--sjt-modal-overlay-color',
    '--sjt-modal-overlay-opacity',
    '--sjt-modal-border-color',
    '--sjt-modal-border-width',
    '--sjt-modal-media-background',
    '--sjt-modal-review-background',
    '--sjt-modal-review-text',
    '--sjt-modal-metadata',
    '--sjt-modal-stars',
    '--sjt-modal-reviewer',
    '--sjt-modal-verified-text',
    '--sjt-modal-product-background',
    '--sjt-modal-product-link',
    '--sjt-modal-close-color',
    '--sjt-modal-close-background',
    '--sjt-modal-close-background-opacity',
    '--sjt-modal-nav-color',
    '--sjt-modal-nav-background',
    '--sjt-modal-nav-background-opacity'
  ];

  let pendingSource = null;
  let pendingTimer = 0;
  let markedModal = null;
  let markedSourceId = null;
  let observer = null;
  let reconcileFrame = 0;

  window[controllerKey] = true;

  const getGalleryShell = (modal) => modal.querySelector(
    ':scope > .jdgm-modal__content[aria-label="Media Gallery"]'
  );

  const isVisible = (element) => {
    if (!element || !element.isConnected) {
      return false;
    }

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  };

  const stopObservingIfIdle = () => {
    if (!pendingSource && !markedModal && observer) {
      observer.disconnect();
      observer = null;
    }
  };

  const clearPending = () => {
    if (pendingTimer) {
      window.clearTimeout(pendingTimer);
      pendingTimer = 0;
    }

    pendingSource = null;
    stopObservingIfIdle();
  };

  const cleanupMarkedModal = () => {
    if (!markedModal) {
      return;
    }

    markedModal.classList.remove(modalMarkerClass);
    modalVariableNames.forEach((name) => markedModal.style.removeProperty(name));
    markedModal = null;
    markedSourceId = null;
    stopObservingIfIdle();
  };

  const startObserving = () => {
    if (observer || !document.body) {
      return;
    }

    observer = new MutationObserver(scheduleReconcile);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'hidden', 'style']
    });
  };

  const markModal = (modal, source) => {
    if (markedModal && markedModal !== modal) {
      cleanupMarkedModal();
    }

    const sourceStyles = window.getComputedStyle(source);
    modalVariableNames.forEach((name) => {
      modal.style.setProperty(name, sourceStyles.getPropertyValue(name).trim());
    });

    modal.classList.add(modalMarkerClass);
    markedModal = modal;
    markedSourceId = source.dataset.sjtSectionId || null;
  };

  const findVisibleTestimonialsModal = () => Array.from(document.querySelectorAll(modalSelector)).find(
    (modal) => isVisible(modal) && Boolean(getGalleryShell(modal))
  );

  const reconcile = () => {
    reconcileFrame = 0;

    if (markedModal && (!isVisible(markedModal) || !getGalleryShell(markedModal))) {
      cleanupMarkedModal();
    }

    if (pendingSource) {
      if (!pendingSource.isConnected || pendingSource.dataset.sjtModalStyling !== 'true') {
        clearPending();
        return;
      }

      const modal = findVisibleTestimonialsModal();
      if (modal) {
        markModal(modal, pendingSource);
        clearPending();
      }
    }

    stopObservingIfIdle();
  };

  function scheduleReconcile() {
    if (reconcileFrame) {
      return;
    }

    reconcileFrame = window.requestAnimationFrame(reconcile);
  }

  const setPendingSource = (source) => {
    clearPending();
    pendingSource = source;
    startObserving();
    scheduleReconcile();
    pendingTimer = window.setTimeout(() => {
      clearPending();
    }, 2000);
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const card = event.target.closest(sourceSelector);
    if (card) {
      if (!event.target.closest(excludedSourceSelector)) {
        setPendingSource(card.closest('.spacetek-judgeme-testimonials'));
      }
      return;
    }

    if (markedModal && event.target.closest('.jm-indicator__close, .jdgm-modal__overlay')) {
      window.requestAnimationFrame(scheduleReconcile);
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && markedModal) {
      window.requestAnimationFrame(scheduleReconcile);
    }
  }, true);

  document.addEventListener('shopify:section:unload', (event) => {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) {
      return;
    }

    if (pendingSource && pendingSource.dataset.sjtSectionId === sectionId) {
      clearPending();
    }

    if (markedSourceId === sectionId) {
      cleanupMarkedModal();
    }
  });
})();
